(function($, w) {
    'use strict';

    function InterestSelected(submitData, interest) {
        if(typeof submitData[interest] !== 'undefined') {
            if(submitData[interest] === 'true') {
                return 1;
            }
        }
        return 0;
    }

    function NewsletterSubmit(formContainerSelector, callback) {

        var $formContainer = $(formContainerSelector);
        var $form = $('form', $formContainer);
        var $error = $('.error', $formContainer);

        var thankyouUrl = '/about-us/newsletter-sign-up/thank-you';
        if($form.attr('data-thankyou-page') !== undefined) {
            thankyouUrl = $form.attr('data-thankyou-page');
        }

        $form.on('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            $form.validate();

            // Reset the error message
            $error.hide();
            $error.html('There is an error when submitting this form, please try it again later.');

            if ($form.valid()) {
                var submitData = [];
                var formData = $form.serializeArray();
                for(var i = 0; i < formData.length; i++) {
                    submitData[formData[i].name] = formData[i].value;
                }

                MCN.SwiftDigital.Subscribe.subscribe({
                    'FIRST_NAME': submitData['NewsLetterForm.FirstName'],
                    'LAST_NAME': submitData['NewsLetterForm.Surname'],
                    'EMAIL': submitData['NewsLetterForm.Email'],
                    'BUSINESS_TYPE': submitData['NewsLetterForm.SelectedType'],
                    'COMPANY': submitData['NewsLetterForm.CompanyName'],
                    'STATE': submitData['NewsLetterForm.SelectedState'],
                    'JOB_TITLE': submitData['NewsLetterForm.Title'],
                    'AREAS_OF_INTEREST_THOUGHT_LEAD': InterestSelected(submitData, 'NewsLetterForm.IsInterestInThoughtLeadership'),
                    'AREAS_OF_INTEREST_DATA_AND_TEC': InterestSelected(submitData, 'NewsLetterForm.IsInterestInDataTechnology'),
                    'AREAS_OF_INTEREST_SPORTS': InterestSelected(submitData, 'NewsLetterForm.IsInterestInSport'),
                    'AREAS_OF_INTEREST_GENERAL_ENTE': InterestSelected(submitData, 'NewsLetterForm.IsInterestInGeneralEntertainment'),
                    'AREAS_OF_INTEREST_STV': InterestSelected(submitData, 'NewsLetterForm.IsInterestInSTV'),
                    'AREAS_OF_INTEREST_FTA': InterestSelected(submitData, 'NewsLetterForm.IsInterestInFTA'),
                    'AREAS_OF_INTEREST_DIGITAL': InterestSelected(submitData, 'NewsLetterForm.IsInterestInDigital'),
                    'AREAS_OF_INTEREST_KIDS': InterestSelected(submitData, 'NewsLetterForm.IsInterestInKids')
                }, 'zzzz5a98e0aee62a3079', function (response) {

                    var success = response.success;
                    if(!success && response.code === '103') {
                        success = true;
                    }

                    if(success) {
                        if(typeof callback === 'function') {
                            callback.call(null);
                        }
                        window.location = thankyouUrl;
                    }
                    else {
                        if(response.code === '104') {
                            $error.html(response.message);
                        }
                        else if( response.code === '102' ) {
                            $error.html('You have previously unsubscribed from this newsletter.');
                        }
                        $error.show();
                    }
                });
            }
        });
    }

    w.MCN = w.MCN || {};
    w.MCN.NewsletterSubmit = NewsletterSubmit;

})(jQuery, window);